import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { createTranslator, readUiLanguage, persistUiLanguage, SUPPORTED_LANGUAGES } from './i18n.js';
const LanguageContext = createContext(null);
export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(readUiLanguage);
  useEffect(() => { document.documentElement.lang = language === 'zh-Hant' ? 'zh-Hant-HK' : 'en'; persistUiLanguage(language); }, [language]);
  const value = useMemo(() => ({ language, t: createTranslator(language), setLanguage: next => { if (SUPPORTED_LANGUAGES.includes(next)) setLanguage(next); } }), [language]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}
export function useLanguage() { return useContext(LanguageContext); }
export function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();
  return <div className="language-switcher" role="group" aria-label="Interface language / 介面語言">
    <button type="button" lang="en" aria-pressed={language === 'en'} onClick={() => setLanguage('en')}>English</button>
    <button type="button" lang="zh-Hant" aria-pressed={language === 'zh-Hant'} onClick={() => setLanguage('zh-Hant')}>繁體中文</button>
  </div>;
}
